import { bookingFlowStoreSelector } from '../../../store';
import { AncillariesBundleConfig } from '../AncillariesBundle/types';

export const useIsBundleDisabled = () => {
  const originalReservationDetails =
    bookingFlowStoreSelector.use.originalReservationDetails?.() || {};
  const originalBundleCode = originalReservationDetails.bundleCode;
  const isUpsellFlow = bookingFlowStoreSelector.use.isUpsellFlow?.();

  const isBundleDisabled = (
    bundle: AncillariesBundleConfig,
    bundles: AncillariesBundleConfig[],
  ) => {
    if (!isUpsellFlow) {
      return false;
    }

    const originalBundleData = bundles.find(
      (bundle) => originalBundleCode === bundle.code,
    ) as AncillariesBundleConfig;

    const selectedBundleCoverageRating = originalBundleData.coverageRating;

    return selectedBundleCoverageRating && bundle.coverageRating
      ? bundle.coverageRating <= selectedBundleCoverageRating &&
          !isBundleIncluded(bundle)
      : true;
  };

  const isBundleIncluded = (bundle: AncillariesBundleConfig) => {
    return isUpsellFlow && originalBundleCode === bundle.code;
  };

  return { isBundleDisabled, isBundleIncluded };
};
